import React from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import About from '../components/About';
import Team from '../components/Team';
import Reviews from '../components/Reviews';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0c]">
      <Navigation />
      <Hero />
      <Services />
      <Portfolio />
      <About />
      <Team />
      <Reviews />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;